import styled from 'styled-components'

const Section = styled.section`
  background: url(${props => props.bgImage || ''}) 50% 50% / cover fixed;
  position: relative;
  min-height: calc(100vh);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  img {
    max-width: 100%;
  }
`

export default Section
